var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms",attrs:{"id":"home"}},[_c('v-e24-nav-bar'),_c('headerResources',{attrs:{"srcImage":_vm.img,"tall":_vm.tall,"h1":"EasyTitle24.com Terms and Conditions"}}),_c('contentTerms'),_c('v-e24-footer',{attrs:{"build":_vm.build}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b07310","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TermsAndConditions.vue
// module id = null
// module chunks = 